import { createContext, useContext, useState } from 'react';

const BrainstormContext = createContext(null);

export function BrainstormProvider({ children }) {
  // activeSession: null | { sessionId, idea, mode, modeColor, currentRound, totalRounds, status }
  const [activeSession, setActiveSession] = useState(null);

  const startSession = ({ sessionId, idea, mode, modeColor, totalRounds }) => {
    setActiveSession({ sessionId, idea, mode, modeColor, currentRound: 0, totalRounds, status: 'running' });
  };

  const updateRound = (roundNumber) => {
    setActiveSession(prev => prev ? { ...prev, currentRound: roundNumber } : prev);
  };

  const completeSession = () => {
    setActiveSession(prev => prev ? { ...prev, status: 'complete' } : prev);
  };

  const clearSession = () => setActiveSession(null);

  return (
    <BrainstormContext.Provider value={{ activeSession, startSession, updateRound, completeSession, clearSession }}>
      {children}
    </BrainstormContext.Provider>
  );
}

export function useBrainstorm() {
  return useContext(BrainstormContext);
}
